/*
 * This file is generated by icons/template.js
 */
const SvgSpeaker = (props: React.SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 22 20" {...props}>
		<path
			fill="#707070"
			fillRule="evenodd"
			d="M8.339 4.623c.598-1.066 2.145-1.079 2.761-.023l.782 1.339a4.86 4.86 0 0 1 3.066 2.274 4.73 4.73 0 0 1 .454 3.753l.883 1.51c.599 1.026-.124 2.313-1.321 2.353l-5.221.174-1.633.932 1.195.985c.505.415.573 1.157.152 1.657a1.2 1.2 0 0 1-1.676.15L5.913 18.19l-1.152.657a1.597 1.597 0 0 1-2.168-.574l-2.38-4.076a1.56 1.56 0 0 1 .58-2.143L5.758 9.22zm6.571 9.638L9.726 5.384 7.145 9.982c-.14.248-.345.455-.594.597l-4.964 2.833 2.38 4.076 4.982-2.844c.226-.129.48-.2.74-.21z"
			clipRule="evenodd"
		/>
		<path
			fill="#707070"
			d="M17.02 6.606c.3.512.968.689 1.485.393l1.882-1.074a1.07 1.07 0 0 0 .398-1.467 1.097 1.097 0 0 0-1.485-.393L17.42 5.139a1.07 1.07 0 0 0-.398 1.467M17.69 11.245a1.04 1.04 0 0 0 .932 1.167c.71.078 1.465.168 2.182.255a1.06 1.06 0 0 0 1.19-.927c-.006-.009.003-.014-.002-.024a1.053 1.053 0 0 0-.938-1.176l-2.172-.261a1.076 1.076 0 0 0-1.194.942c.005.01.001.024.001.024M15.146.1c-.005-.01-.015-.004-.02-.013a1.07 1.07 0 0 0-1.407.555c-.282.657-.59 1.354-.862 2.005a1.047 1.047 0 0 0 .571 1.386c.005.01.015.004.02.013a1.07 1.07 0 0 0 1.408-.555c.286-.648.58-1.348.861-2.005.231-.529-.03-1.148-.57-1.386"
		/>
	</svg>
);
SvgSpeaker.displayName = 'iconSpeaker';
export default SvgSpeaker;
